<template>
  <div class="result">
   <h1>Feedback</h1>
   <img class="result__img" :src='this.$root.$data.imagePrefix +"intro-compass.gif"'>
   <p class="result__h2 h2">{{ feedback[selectedFeedbackId].title }}</p>
   <p v-html="feedback[selectedFeedbackId].description"></p>
   <p class="result__copy">Sie interessieren sich für einen Einstieg bei der badenovaGRUPPE? <a target="_blank" href="https://www.karriere-badenova.de/Stellenangebote/">Entdecken Sie hier Ihre Möglichkeiten</a>!</p>
    
  <div class="buttonGroup">
  <a class="button button--orange" target="_blank" href="https://www.karriere-badenova.de/Stellenangebote/">Stellenanzeigen</a>
  <a class="button button--orange" target="_blank" href="https://www.badenova.de/ueber-uns/wir-sind/unsere-werte/">unsere Werte</a>
  </div>
    <div class="buttonGroup">
  <button class="button button--border" @click="reload()">Neu Starten</button>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Result',
  props: {
    score: Number,
    maxscore: Number,
    feedback: Array
  },
  data() {
    return {
      selectedFeedbackId: 0,
      scorePercentage: 0
    }
  },
  methods: {
    reload: function() {
      window.location.reload(true);
    },
    resultTracking: function(scoreId) {
      let eventLabel = 'no match'
      if(scoreId === 1) {
        eventLabel = 'neutral'
      }
      if(scoreId === 2) {
        eventLabel = 'match'
      }
      if(window.dataLayer !== undefined) {
        window.dataLayer.push({
          'event':'event',
          'eventCategory': 'Corporate Values Application',
          'eventAction': 'Application Results',
          'eventLabel': eventLabel
        });
      }
    }
  },
  created() {
      this.scorePercentage = this.score / this.maxscore * 100;
      for (var i = 0; i < this.feedback.length; i++) {
        if(this.feedback[i].neededScoreInPercent <= this.scorePercentage) {
          this.selectedFeedbackId = i;
        }
      }
      this.resultTracking(this.selectedFeedbackId);
  }
}
</script>
<style lang="scss" scoped>
.result {
  @media (min-width: 768px) {
    width: 600px;
    margin: 0 auto;
  }
  &__copy {
    margin-top: 20px;
  }
  a:not(.button) {
    color: #f60;
    &:hover {
      color: #1d009c;
    }
  }

    &__img {
    width: 100%;
    height: auto;

    @media (min-width: 576px) {
      width: 75%;
    }

    @media (min-width: 1024px) {
      width: 75%;
    } 
  }
  &__h2 {
    margin-top: 20px;
    margin-bottom: 15px;
  }
}
.buttonGroup {
  margin-top: 20px;
  .button {
    margin: 5px;
  }
}
</style>